module.exports = __webpack_public_path__ + "static/media/branding-img14.0ff69f21.jpg";